<template>


  <CChartBar
    :datasets="defaultDatasets"
    :options="computedOptions"
    :labels="chartLabel"
  />
 

</template>

<script>
import { CChartBar } from 'vue-chartjs-new'
import {  deepObjectsMerge } from '@coreui/utils/src'
export default {
  name: 'CChartBarDouble',
  components: { CChartBar },
   props: {
    ...CChartBar.props,
    backgroundColor: {
      type: String,
      default: 'rgba(0,0,0,.2)'
    },
    pointHoverBackgroundColor: String,
    todaySales: {
      type: Array,
      
    },
    lastWeek: {
      type: Array,
      
    },
    chartLabel: {
      type: Array|String,
      
    },
    // label: {
    //   type: String,
    //   default: 'Sales'
    // },
    pointed: Boolean,
    pointHoverBackgroundColor: String
  },
  computed: {
    defaultDatasets () {
      return [
        /*{
          label: 'Day by Day',
          backgroundColor: '#f87979',
          data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
          borderWidth: 0.5,
        }*/
        
                              {
                                label: this.$t("dashBoard.cChartBarDouble.salesCompLabel1"),
                                backgroundColor: '#14AFFC',
                                //borderColor: "red",
                                borderWidth: 1,
                                data: this.todaySales
                              },
                              {
                                label: this.$t("dashBoard.cChartBarDouble.salesCompLabel2"),
                                backgroundColor: '#96DCFF',
                                //borderColor: "blue",
                                borderWidth: 1,
                                data: this.lastWeek
                              },                             
                          
      ]
    },
     defaultOptions () {
      return {
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            display: true
          }],
          yAxes: [{
            display: true
          }]
        }
      }
    },
    
    computedOptions () {
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    }
  }
}
</script>
